/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { NftRewardPrize } from './NftRewardPrize';
import {
    NftRewardPrizeFromJSON,
    NftRewardPrizeFromJSONTyped,
    NftRewardPrizeToJSON,
    NftRewardPrizeToJSONTyped,
} from './NftRewardPrize';

/**
 * 
 * @export
 * @interface GetNftRewardPrizesForAdminResponse
 */
export interface GetNftRewardPrizesForAdminResponse {
    /**
     * 
     * @type {Array<NftRewardPrize>}
     * @memberof GetNftRewardPrizesForAdminResponse
     */
    prizes?: Array<NftRewardPrize>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetNftRewardPrizesForAdminResponse
     */
    paginationInfo: PaginationInfo;
}

/**
 * Check if a given object implements the GetNftRewardPrizesForAdminResponse interface.
 */
export function instanceOfGetNftRewardPrizesForAdminResponse(value: object): value is GetNftRewardPrizesForAdminResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    return true;
}

export function GetNftRewardPrizesForAdminResponseFromJSON(json: any): GetNftRewardPrizesForAdminResponse {
    return GetNftRewardPrizesForAdminResponseFromJSONTyped(json, false);
}

export function GetNftRewardPrizesForAdminResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNftRewardPrizesForAdminResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'prizes': json['prizes'] == null ? undefined : ((json['prizes'] as Array<any>).map(NftRewardPrizeFromJSON)),
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
    };
}

export function GetNftRewardPrizesForAdminResponseToJSON(json: any): GetNftRewardPrizesForAdminResponse {
    return GetNftRewardPrizesForAdminResponseToJSONTyped(json, false);
}

export function GetNftRewardPrizesForAdminResponseToJSONTyped(value?: GetNftRewardPrizesForAdminResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prizes': value['prizes'] == null ? undefined : ((value['prizes'] as Array<any>).map(NftRewardPrizeToJSON)),
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
    };
}

